<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="() => $router.push({ name: 'professores' })">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Quadro de Horário Professor(a):
          {{ professor ? professor?.nome : "[NÃO INFORMADO]" }}
        </h1>

        <div v-if="gestoesDeAulas.length === 0" style="text-align: center">
          <v-alert color="warning" icon="fa fa-frown-o"
            >Nenhum Quadro de Horário disponível para este professor.</v-alert
          >
        </div>

        <v-simple-table v-if="gestoesDeAulas.length > 0">
          <thead>
            <tr>
              <th style="text-align: center">Dia/Horário</th>
              <th
                v-for="(horario, idx) in horariosUnicos"
                :key="`horario-${horario.id}-${idx}`"
                style="text-align: center"
              >
                {{ horario.descricao }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dia, index) in diasUnicos" :key="index">
              <td class="dia-coluna">
                <span class="dia-abreviado">{{ dia.descricao.slice(0, 3) }}</span>
                <span class="dia-completo">{{ dia.descricao }}</span>
              </td>
              <td
                v-for="(horario, i) in horariosUnicos"
                :key="`cell-${dia.id}-${horario.id}-${i}`"
                :class="{
                  'multiple-classes': getTodasTurmasDisciplinas(dia.id, horario.id).length > 1,
                  'has-content': getTodasTurmasDisciplinas(dia.id, horario.id).length > 0,
                }"
                :style="
                  getTodasTurmasDisciplinas(dia.id, horario.id).length === 1
                    ? {
                        backgroundColor: getCorPorDisciplina(
                          getTodasTurmasDisciplinas(dia.id, horario.id)[0].disciplina
                        ),
                      }
                    : {}
                "
              >
                <div
                  v-for="(aula, idx) in getTodasTurmasDisciplinas(dia.id, horario.id)"
                  :key="`aula-${idx}`"
                  class="aula-item"
                  :style="{
                    backgroundColor:
                      getTodasTurmasDisciplinas(dia.id, horario.id).length > 1
                        ? getCorPorDisciplina(aula.disciplina)
                        : undefined,
                    borderBottom:
                      getTodasTurmasDisciplinas(dia.id, horario.id).length > 1 &&
                      idx < getTodasTurmasDisciplinas(dia.id, horario.id).length - 1
                        ? '2px solid #ccc'
                        : undefined,
                  }"
                >
                  {{ aula.disciplina }}<br />
                  {{ aula.turma }}
                </div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-row v-if="gestoesDeAulas.length > 0" class="no-print mt-3">
          <v-col class="text-right">
            <v-btn color="primary" @click="imprimirQuadro">
              <v-icon left>mdi-printer</v-icon>
              Imprimir Quadro
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
export default {
  data() {
    return {
      professor: [],
      gestoesDeAulas: [],
      horariosUnicos: [],
      diasUnicos: [],
      diasDaSemana: [
        { id: "Segunda-feira", descricao: "Segunda-feira", ordem: 1 },
        { id: "Terça-feira", descricao: "Terça-feira", ordem: 2 },
        { id: "Quarta-feira", descricao: "Quarta-feira", ordem: 3 },
        { id: "Quinta-feira", descricao: "Quinta-feira", ordem: 4 },
        { id: "Sexta-feira", descricao: "Sexta-feira", ordem: 5 },
        { id: "Sábado", descricao: "Sábado", ordem: 6 },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.$loaderService.open("Carregando Professor");
        const { professor_id } = this.$route.params;
        const data = await this.$services.professoresService.quadroHorario(professor_id);

        this.professor = data.data[0];
        this.gestoesDeAulas = data.data[0].gestoes_de_aulas;
        this.processarGestaoDeAulas();
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    processarGestaoDeAulas() {
      const dias = new Map();
      const horariosMap = new Map();
      const normalizarDia = (descricao) => {
        const diaDescricao = descricao.trim();
        const mapeamentoDias = {
          Segunda: "Segunda-feira",
          Terça: "Terça-feira",
          Quarta: "Quarta-feira",
          Quinta: "Quinta-feira",
          Sexta: "Sexta-feira",
        };

        return mapeamentoDias[diaDescricao] || diaDescricao;
      };

      this.gestoesDeAulas.forEach((gestao) => {
        gestao.relacoesDiasHorarios.forEach((relacao) => {
          const diaNormalizado = normalizarDia(relacao.dia.descricao);

          if (!dias.has(diaNormalizado)) {
            const diaConfig = this.diasDaSemana.find((d) => d.descricao === diaNormalizado);
            dias.set(diaNormalizado, {
              id: diaNormalizado,
              descricao: diaNormalizado,
              ordem: diaConfig ? diaConfig.ordem : 99,
            });
          }

          if (!horariosMap.has(relacao.horario.id)) {
            horariosMap.set(relacao.horario.id, {
              id: relacao.horario.id,
              descricao: relacao.horario.descricao,
            });
          }
        });
      });

      this.diasUnicos = Array.from(dias.values()).sort((a, b) => a.ordem - b.ordem);
      this.horariosUnicos = Array.from(horariosMap.values()).sort((a, b) => a.id - b.id);
    },

    getTodasTurmasDisciplinas(diaId, horarioId) {
      const normalizarDia = (descricao) => {
        const diaDescricao = descricao.trim();
        const mapeamentoDias = {
          Segunda: "Segunda-feira",
          Terça: "Terça-feira",
          Quarta: "Quarta-feira",
          Quinta: "Quinta-feira",
          Sexta: "Sexta-feira",
        };
        return mapeamentoDias[diaDescricao] || diaDescricao;
      };

      const aulas = [];

      this.gestoesDeAulas.forEach((gestao) => {
        const relacoes = gestao.relacoesDiasHorarios.filter(
          (r) => normalizarDia(r.dia.descricao) === diaId && r.horario.id === horarioId
        );

        relacoes.forEach((relacao) => {
          if (gestao.is_polivalencia) {
            aulas.push({
              turma: gestao.turma?.descricao || "Turma não definida",
              disciplina: relacao.disciplina?.descricao || "Polivalência",
            });
          } else {
            aulas.push({
              turma: gestao.turma?.descricao || "Turma não definida",
              disciplina: gestao.disciplina?.descricao || "Disciplina não definida",
            });
          }
        });
      });

      return aulas;
    },

    getTurmaDisciplina(diaId, horarioId) {
      if (!this.gestoesDeAulas || !this.gestoesDeAulas.relacoesDiasHorarios) return null;

      const relacao = this.gestoesDeAulas.relacoesDiasHorarios.find(
        (r) => r.dia.id === diaId && r.horario.id === horarioId
      );

      return relacao
        ? {
            turma: this.gestoesDeAulas.turma?.descricao || "Turma não definida",
            disciplina: this.gestoesDeAulas.disciplina?.descricao || "Polivalência",
          }
        : null;
    },

    getCorPorDisciplina(disciplina) {
      disciplina = disciplina.toUpperCase();
      disciplina = disciplina.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

      const corPorDisciplina = {
        // Línguas - tons de laranja/pêssego
        "LINGUA PORTUGUESA": "#FFCC99",
        "LINGUA INGLESA": "#FFD6A5",
        "ESTUDO ORIENTADO DE LINGUA PORTUGUESA": "#FFB86C", // tom mais escuro de laranja
        "LINGUA ESTRANGEIRA - INGLES": "#FFEAD0", // tom mais claro

        // Matemática - tons de amarelo
        MATEMATICA: "#FDFFB6",
        "ESTUDO ORIENTADO DE MATEMATICA": "#FFF59D", // tom mais vibrante

        // Ciências - tons de verde
        CIENCIAS: "#A2E4B8",
        "INICIACAO CIENTIFICA": "#C8E6C9",
        "HORTA ESCOLAR": "#81C784", // verde mais forte

        // Humanas - tons de azul
        HISTORIA: "#99D1FF",
        GEOGRAFIA: "#A0C4FF",

        // Artes e Expressão - tons de verde claro/menta
        ARTE: "#B9FBC0",
        MUSICA: "#A7F3D0",
        "DO LIVRO AO PALCO": "#D4F1F4",
        "TRACOS, SONS, CORES E FORMAS": "#B2F5EA",

        // Educação Física e Movimento - tons de ciano/turquesa
        "EDUCACAO FISICA": "#98F5E1",
        ESPORTE: "#7FDBDA",
        CAPOEIRA: "#5FD3D1",
        "CORPO, GESTOS E MOVIMENTOS": "#81E6D9",
        "SAUDE, CORPO E MENTE": "#A0E7E5",

        // Desenvolvimento Pessoal - tons de roxo/lilás
        "ENSINO RELIGIOSO": "#E2D1F9",
        "PROJETO DE VIDA": "#D4BBFF",
        EMPREENDEDORISMO: "#C4A7E7",

        // Inclusão Social - tons de roxo/lilás
        "ROMPENDO PRECONCEITOS": "#B39DDB",

        // Educação Infantil - tons de rosa
        "EDUCACAO INFANTIL": "#FFC6FF",
        "ENSINO INFANTIL": "#FFC6FF",
        "ESPACOS, TEMPOS, QUANTIDADES E TRANSFORMACOES": "#FFB3E6",
        "O EU, O OUTRO E O NOS": "#FFD4F4",
        "ESCUTA, FALA, PENSAMENTO E IMAGINACAO": "#FFABE1",

        // Polivalência - cinza
        POLIVALENCIA: "#E2E2E2",
      };

      const corEncontrada = Object.keys(corPorDisciplina).find((key) => disciplina.includes(key));

      return corEncontrada ? corPorDisciplina[corEncontrada] : "#ffffff";
    },

    async imprimirQuadro() {
      try {
        const { professor_id } = this.$route.params;
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.imprimirQuadroHorarioProfessor(professor_id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style scoped>
th {
  text-align: center;
  background-color: #e0e0e0;
  padding: 10px;
}
td {
  text-align: center;
  padding: 0;
  border: 1px solid #ccc;
  vertical-align: middle;
}

.multiple-classes {
  padding: 0 !important;
}

.aula-item {
  padding: 10px;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.aula-item:last-child {
  border-bottom: none;
}

td:not(.dia-coluna) {
  padding: 0 !important;
  height: 100%;
}

/* Quando há apenas uma aula, ela ocupa toda a altura da célula */
td:not(.dia-coluna):has(> div:only-child) {
  height: 100%;
}

td:not(.dia-coluna) > div:only-child {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.coluna-duplicada {
  border-left: 3px solid #fb9716 !important;
}

.dia-completo {
  display: none;
}

.dia-abreviado {
  display: inline;
}

@media print {
  .no-print,
  .v-navigation-drawer,
  .v-app-bar,
  .v-footer,
  button {
    display: none !important;
  }

  .v-main {
    padding: 0 !important;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
    page-break-inside: avoid;
  }

  td {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  th {
    background-color: #fb9716 !important;
    color: white !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    font-weight: bold;
  }

  th,
  td {
    border: 1px solid #333 !important;
    padding: 8px !important;
  }

  h1 {
    font-size: 18pt;
    margin-bottom: 10px;
    color: #000;
  }

  .v-simple-table {
    page-break-after: always;
  }

  .dia-abreviado {
    display: none;
  }

  .dia-completo {
    display: inline;
  }
}
</style>
